import { EPS } from './epsilon.js';
/**
 * Are these the same unit?
 *
 * A missing signature never matches: an unparseable unit is not equal to anything, including
 * another unparseable one.
 */
export function sameUnitSignature(a, b) {
    if (!a || !b)
        return false;
    if (a.dims !== b.dims)
        return false;
    // Through EPS rather than `===`: these arrive from floating-point sampling, where `1 permille` in
    // `ppm` comes back as 1000.0000000000001.
    if (Math.abs(a.factor - b.factor) > EPS(Math.max(Math.abs(a.factor), Math.abs(b.factor))))
        return false;
    if (Math.abs(a.offset - b.offset) > EPS(Math.max(Math.abs(a.offset), Math.abs(b.offset), 1)))
        return false;
    // Compared only when BOTH are named. `J` and `N*m` share a signature and one is a composition of
    // the other, so a student answering in longhand has still answered correctly; only
    // named-versus-named — `Gy` against `Sv` — is a distinction worth enforcing.
    if (a.family && b.family && a.family !== b.family)
        return false;
    return true;
}
//# sourceMappingURL=unit-signature.js.map